module.exports = __webpack_public_path__ + "img/shouyi2.2c222b71.png";